import * as _ from 'lodash-es'

export default {
  data() {
    return {
      filters: []
    }
  },
  computed: {
    filteredEntries() {
      let tempEntries = this.entries

      const resultsMap = new Map()

      if (this.filters.length) {
        tempEntries.forEach((_, idx) => resultsMap.set(idx, true)) // Par défaut, tout passe

        this.filters.forEach((filter, index) => {
          const allNotNull = Object.values(filter).every(
            (value) => value !== null
          )

          if (!allNotNull) return

          if (allNotNull) {

            const attribute = this.metadata.filters?.find(
              (availableFilter) => availableFilter.id === filter.column
            )?.attributes

            const operatorFn = this.$h.operators[filter.condition]

            if (!operatorFn) return

            //Aurélie: Modifier car ne fonctionnait pas quand on utilisait plusieurs filtres ET Logique et OU logique
            tempEntries.forEach((entry, idx) => {
              const filterValues = filter.values.id ?? filter.values
              const entryValue = _.get(entry, attribute)

              const conditionResult = operatorFn(entryValue, filterValues)

              if (filter.whereType === 'where') {
                resultsMap.set(idx, resultsMap.get(idx) && conditionResult)
              } else if (filter.whereType === 'orWhere') {
                resultsMap.set(idx, resultsMap.get(idx) || conditionResult)
              }
            })
          }
        })

        tempEntries = tempEntries.filter((_, idx) => resultsMap.get(idx))
      }

      return tempEntries
    }
  },
  methods: {
    handleUpdateFilters(value) {

      this.filters = value
    }
  }
}
